import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
	legendSpacing,
	colorScheme,
	chartColors,
	responsiveDataLabelSize,
	responsiveTickLabelSize
} from './utilities';

Chart.register(ChartDataLabels);

function generateBarChart(chartWrapper, chartData, chartSettings) {
	let data = chartData.datasets;
	let colors = colorScheme(chartSettings.color_scheme);

	// Our vertical bar charts have only one dataset
	let datasets = data.map((item, index) => {
		let colorKey = item.label.toLowerCase();
		let legendColors = chartColors(chartSettings.chart_colors);
		let backgroundColor = legendColors[colorKey] || legendColors[Object.keys(legendColors)[index % Object.keys(legendColors).length]];

		return {
			label: item.label,
			data: item.data,
			backgroundColor: backgroundColor,
		};
	});

	Chart.defaults.color = colors.labels;
	Chart.defaults.borderColor = colors.grid;

	new Chart(chartWrapper, {
		type: 'bar',
		data: {
			labels: chartData.labels,
			datasets: datasets,
		},
		plugins: [legendSpacing],
		options: {
			indexAxis: chartSettings.index_axis,
			responsive: true,
			maintainAspectRatio: false,
			plugins: {
				title: {
					display: true,
					text: chartData.title,
					color: colors.labels,
					align: 'start',
					font: {
						size: 16,
						weight: 'bold'
					},
				},
				legend: {
					display: datasets.length > 1,
					labels: {
						boxWidth: 12,
						boxHeight: 12,
						useBorderRadius: true,
						borderRadius: 6,
						padding: 10,
						color: colors.labels,
					},
				},
				datalabels: {
					anchor: 'end',
					align: (context) => {
						if (chartSettings.index_axis === 'x') {
							return 'end';
						}
						// Move the labels inside the bar on higher values for horizontal bar charts
						const value = context.dataset.data[context.dataIndex];
						const dataset = context.dataset.data;
						const midpoint = Math.max(...dataset) / 2;
						return value < midpoint ? 'end' : 'start';
					},
					formatter: (value) => {
						if (value) {
							return value.toLocaleString()
						} else {
							return '';
						}
					},
					font: responsiveDataLabelSize,
					color: colors.labels,
				},
			},
			scales: {
				x: {
					grid: {
						display: chartSettings.index_axis === 'y',
						color: colors.grid,
					},
					title: {
						display: !!chartSettings.x_axis_title,
						text: chartSettings.x_axis_title,
						font: {
							size: 14,
						}
					},
					ticks: {
						maxTicksLimit: 10,
						maxRotation: 0,
						padding: 10,
						autoSkipPadding: 15,
						font: {
							size: 11,
						},
					},
				},
				y: {
					grid: {
						color: colors.grid,
					},
					title: {
						display: !!chartSettings.y_axis_title,
						text: chartSettings.y_axis_title,
						font: {
							size: 14,
						}
					},
					ticks: {
						display: true,
						autoSkip: false,
						autoSkipPadding: 15,
						padding: 0,
						font: responsiveTickLabelSize,
					},
				},
			},
		}
	});
}

export {generateBarChart};
